import { JobMode } from '../Node/source-type/job-mode';

export function getJobModeValue(jobMode: JobMode) {
  return jobMode?.virtualValue || jobMode?.value;
}

export function getRecommendedJobMode(jobModes: JobMode[]) {
  return (jobModes || []).find(mode => mode.isRecommended);
}
